import { initContract } from '@ts-rest/core';
const c = initContract();
export const canvaContract = c.router({
    getById: {
        method: 'GET',
        path: '/canva/:id',
        pathParams: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    getByChatId: {
        method: 'GET',
        path: '/canva',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    updateById: {
        method: 'PUT',
        path: '/canvas/:id',
        body: c.type(),
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
});
//# sourceMappingURL=canva.js.map